// Shared colour-coded status classification — used by the ticket-card grid
// (KioskTicketList) and the ticket detail status banner (KioskTicketWorkspace)
// so both surfaces agree on what each status looks like.

import type { TicketStatus } from '../hooks/useWbTickets';
import styles from './kiosk.module.css';

export function statusPillClass(status: TicketStatus): string {
  switch (status) {
    case 'open':
      return `${styles.statusPill} ${styles.statusOpen}`;
    case 'completed':
      return `${styles.statusPill} ${styles.statusCompleted}`;
    case 'voided':
      return `${styles.statusPill} ${styles.statusVoided}`;
    default:
      return `${styles.statusPill} ${styles.statusDraft}`;
  }
}
